import {useEffect, useState} from "react";
import {IDetailBooking} from "../../utils/interfaces/IDetailBooking";
import DetailBookingRow from "./DetailBookingRow";
import {IBooking} from "../../utils/interfaces/IBooking";
import {motion} from "framer-motion";


interface DetailsBookingListProps {
    obj: IBooking,
}

function DetailsBookingList({obj: initialObj}: DetailsBookingListProps) {
    const [obj, setObj] = useState<IBooking>(initialObj)

    const mapped_objs = obj?.details.map((obj: IDetailBooking, index) => (
        <motion.tr
            initial={{opacity: 0, y: 30}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.5}}
        >
            <DetailBookingRow obj={obj}/>
        </motion.tr>
    ));

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <motion.table
                className="bg-mcia_gray_soft shadow-xl rounded-lg p-4 mb-4 w-[500px] relative"
                initial={{x: '100%'}}
                animate={{x: '0%'}}
                transition={{duration: 0.2}}
            >

                <thead className='mycia_thead'>
                <tr className='mb-0.5'>
                    <th className="cisco_th rounded-tl">
                        <span className="mr-2">Reserved</span>
                        <span className="mr-8">At</span>
                    </th>
                    <th className="cisco_th">
                        <span className="mr-2">Reserved</span>
                        <span className="mr-8">Time</span>
                    </th>
                    <th className="cisco_th">
                        <span className="mr-10">Seats</span>
                    </th>
                    <th className="cisco_th">
                        <span className="mr-2">Seat</span>
                        <span className="mr-8">Price</span>
                    </th>
                    <th className="cisco_th">
                        <span className="mr-2">Net</span>
                        <span className="mr-8">Price</span>
                    </th>
                    <th className="cisco_th">
                        <span className="mr-20">Vat</span>
                    </th>
                    <th className="cisco_th rounded-tr">
                        <span className="mr-2">Gross</span>
                        <span className="mr-8">Price</span>
                    </th>
                </tr>
                </thead>
                <tbody>
                {mapped_objs}
                </tbody>

            </motion.table>


        </>
    )
}

export default DetailsBookingList;